import { useEffect, useRef } from 'react';
export function useInitializedRef(initializer) {
    const isMounted = useRef(false);
    const ref = useRef(isMounted.current || initializer());
    useEffect(() => {
        isMounted.current = true;
    }, []);
    return ref;
}
//# sourceMappingURL=use-initialized-ref.js.map